var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 12,
  viewBox: "0 0 24 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Polygon_50",
  "data-name": "Polygon 50",
  d: "M12,0,24,12H0Z",
  fill: "#2fba49"
})));
export default __webpack_public_path__ + "static/media/greenArrow.068a94c6.svg";
export { SvgComponent as ReactComponent };